import { jsx as _jsx } from "react/jsx-runtime";
import { Spinner } from 'react-bootstrap';
export const LoadingSpinner = () => (_jsx("div", Object.assign({ style: {
        width: '100vw',
        display: 'flex',
        justifyContent: 'center',
        marginTop: '5rem'
    } }, { children: _jsx(Spinner, { animation: 'border', variant: 'primary', style: {
            height: '5rem',
            width: '5rem'
        } }) })));
export const LoadingScreen = () => (_jsx("div", Object.assign({ className: 'full-screen-icon-container' }, { children: _jsx(LoadingSpinner, {}) })));
